export default __webpack_public_path__ + "assets/tutorial-door.json";